module.exports = __webpack_public_path__ + "img/Unidad15-2.1db2eef2.png";